<div data-e2e-id="graphql-integrated">
  <h2>GraphQL Integrated Demo</h2>

  <p>
    Integrated GraphQL executes GraphQL queries within the Layout Service endpoint, and merges
    the query results into the Layout Service result JSON. The query results can be seen by
    inspecting the Layout Service response in the browser devtools network tab.
  </p>

  <div>
    <h4>Datasource Item (via Integrated GraphQL)</h4>
    id: {{ queryResult.data.datasource.id }}
    <br />
    name: {{ queryResult.data.datasource.name }}
    <br />
    sample1: {{ queryResult.data.datasource.sample1.value }}
    <br />
    sample1 (editable): <span *scText="queryResult.data.datasource.sample1.jsonValue"></span>
    <br />
    sample2:<br />
    <ul>
      <li>text: {{ queryResult.data.datasource.sample2.text }}</li>
      <li>url: {{ queryResult.data.datasource.sample2.url }}</li>
      <li>target: {{ queryResult.data.datasource.sample2.target }}</li>
      <li>
        editable: <a *scLink="queryResult.data.datasource.sample2.jsonValue"></a>
      </li>
      <li>field type: {{ queryResult.data.datasource.sample2.definition.type }}</li>
      <li>field is shared?: {{ queryResult.data.datasource.sample2.definition.shared.toString() }}</li>
    </ul>
  </div>

  <div>
    <h4>Route Item (via Integrated GraphQL)</h4>
    id: {{ queryResult.data.contextItem.id }}
    <br />
    page title: {{ queryResult.data.contextItem.pageTitle.value }}
    <br />
    children:
    <ul>
      <li *ngFor="let child of queryResult.data.contextItem.children.results">
        <a [routerLink]="child.url.path">{{ child.pageTitle.value }}</a>
        (editable title too! <span *scText="child.pageTitle.jsonValue"></span>)
      </li>
    </ul>
  </div>
</div>
